import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificacaoService } from '../service/notificacao.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private notificacao: NotificacaoService) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = '';
                if (error.error instanceof ErrorEvent) {
                    // client-side error
                    errorMessage = `Error: ${error.error.message}`;
                } else {
                    // server-side error
                    if (error?.error?.errors) {
                        for (const erro of error.error.errors) {
                            errorMessage += `${erro.defaultMessage}\n`;
                            this.notificacao.error(erro.defaultMessage);
                        }
                    } else if (error.error?.message || error.error?.userMessage) {
                        errorMessage = error.error?.message || error.error?.userMessage;
                        try {
                            let e = JSON.parse(errorMessage);
                            errorMessage = (e.error || e.message || e.detail || errorMessage);
                        } catch {}
                        this.notificacao.error(errorMessage);
                    } else if (error?.status !== 401) {
                        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
                        this.notificacao.error(errorMessage);
                    }
                }
                return throwError(errorMessage);
            })
        );
    }
}
